export function mapInventoryLocation(location : string): string {
    switch(location) {
        case "TRANSIT": {
            return "Transit"
        }
        case "NIPPGNK": {
            return "Genk"
        }
        default: {
            return location
        }
    }
}